import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-signature-choice-dialog",
  templateUrl: "./signature-choice-dialog.component.html",
  styleUrls: ["./signature-choice-dialog.component.scss"],
  standalone: false,
})
export class SignatureChoiceDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<SignatureChoiceDialogComponent>,
  ) {}

  chooseGenerator(): void {
    this.dialogRef.close("generator");
  }

  chooseManual(): void {
    this.dialogRef.close("manual");
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
